module.exports = __webpack_public_path__ + "media/images/icon/warning-abb57abcdd8e1653d82d56f731ff578d.svg";